module.exports = __webpack_public_path__ + "static/testimonial-podium-logo.3dd537b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/testimonials/testimonial-podium-logo.png
// module id = 1303
// module chunks = 35783957827783